import { motion } from "framer-motion";
import BlogCard from "./BlogCard";
import blogData from "@/data/blog.json";

export default function BlogList() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {blogData.map((post, index) => (
        <motion.div
          key={post.slug}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
        >
          <BlogCard
            title={post.title}
            summary={post.summary}
            slug={post.slug}
            date={post.date}
            author={post.author}
            image={post.image}
            category={post.category}
          />
        </motion.div>
      ))}
    </div>
  );
}
